<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h2>{{ $t('delete.service') }}</h2>
    </div>
    <div class="modal-content">
      <div class="edit-queue">
        <form
          id="form-delete-table-1"
          action=""
        >
          <p>{{ $t('delete.service.text') }} <strong>"{{ service.title[$i18n.locale()] }}"</strong>?</p>

          <div class="form-actions">
            <button
              type="button"
              class="btn-secondary"
              @click="close"
            >
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn-warning btn-active main-action"
              @click="deleteService()"
            >
              {{ $t('delete') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import api from '@/api'

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    ...mapActions([
      'fetchServices'
    ]),
    close () {
      this.$emit('input', false)
    },
    async deleteService () {
      api.deleteService({ serviceID: this.service.id })
      await this.fetchServices()
      this.close()
    }
  }
}
</script>
